var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tab',{attrs:{"title-link-attributes":_vm.linkAttributes,"title-item-class":_vm.lineClass,"disabled":_vm.disabled,"active":_vm.active},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"timeline-tab-title",attrs:{"data-time":_vm.dateTimeText}},[_vm._v(_vm._s(_vm.title))])]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }